/**
 * PrivyTokenBridge — no-op component kept for backward compatibility.
 *
 * The global fetch interceptor it used to install has been removed.
 * Auth is now handled explicitly inside `apiFetch()` (lib/marketing/api.ts),
 * which calls `getAccessToken()` directly on every authenticated request.
 */
export function PrivyTokenBridge() {
  return null;
}
